// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__Z9Z4k","menu":"Header_menu__bKlxq","active":"Header_active__rHuVo","safari":"Header_safari__z5Gxw"};